import * as braze from '@braze/web-sdk';
import { isBrazeInitialized } from 'consent/initBraze';

/**
 * Logs a custom event to Braze for the currently identified user
 * (see `braze.changeUser` in useBrazeNotifications).
 *
 * No-ops (with a console warning) if the SDK hasn't finished initializing yet,
 * e.g. events fired before `useBrazeNotifications` completes its user/session setup.
 *
 * @see https://js.braze.com/docs/developer_guide/platform_wide/analytics/#custom-events
 */
export const logBrazeEvent = (
  eventName: string,
  eventProperties?: Record<string, unknown>
): void => {
  if (!isBrazeInitialized()) {
    console.warn(`[Braze] SDK not initialized, skipping event`);
    return;
  }

  braze.logCustomEvent(eventName, eventProperties);
};
